import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=7a476c8c&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=7a476c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a476c8c",
  null
  
)

export default component.exports